import React, { useState, useEffect } from 'react';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';

/**
 * PlateDynamicInputList 組件，用於動態生成輸入欄位。
 * @param {React.Component} icon - 要顯示的圖標組件。
 * @param {string} placeholder - 每個輸入欄位的佔位符文本。
 * @param {number} maxItems - 輸入欄位的最大數量。
 * @param {array} initialItems - 初始輸入欄位的數據。
 * @param {function} onItemsChange - 當輸入欄位內容變化時調用的回調函數。
 */
const PlateDynamicInputList = ({ icon: Icon, placeholder, maxItems, initialItems, onItemsChange }) => {
  const [items, setItems] = useState(initialItems);

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  /**
   * 當點擊添加按鈕時調用，增加一個新的空輸入欄位。
   */
  const handleAddItem = () => {
    if (items.length < maxItems) {
      const newItems = [...items, ''];
      setItems(newItems);
      onItemsChange(newItems); // 每次新增時觸發回調函數
    }
  };

  /**
   * 當點擊刪除按鈕時調用，刪除對應索引的輸入欄位，但不能刪除第一個輸入欄位。
   * @param {number} index - 要刪除的輸入欄位索引。
   */
  const handleRemoveItem = (index) => {
    if (index > 0) { // 防止刪除第一個輸入欄位
      const newItems = items.filter((_, i) => i !== index);
      setItems(newItems);
      onItemsChange(newItems); // 每次刪除時觸發回調函數
    }
  };

  /**
   * 當輸入欄位內容變化時調用，更新對應索引的值。
   * @param {number} index - 輸入欄位的索引。
   * @param {object} event - 輸入事件對象。
   */
  const handleChange = (index, event) => {
    const value = event.target.value;
    // 驗證輸入是否符合要求
    if (/^[a-zA-Z0-9]*$/.test(value) && value.length <= 7) {
      const newItems = [...items];
      newItems[index] = value;
      setItems(newItems);
      onItemsChange(newItems); // 每次修改時觸發回調函數
    }
  };

  return (
    <>
      {items.map((item, index) => (
        <div className="input-field" key={index}>
          <label htmlFor={`item${index}`}><Icon /></label>
          <input
            type="text"
            name={`item${index}`}
            placeholder={`${placeholder} (${index + 1})`}
            id={`item${index}`}
            className="box"
            value={item}
            onChange={(event) => handleChange(index, event)}
          />
          {item ?
            (index === items.length - 1 && items.length < maxItems && (<div className="fieldNoticeIcon" onClick={handleAddItem}><FaPlusCircle /></div>))
            : (index > 0 && <div className="fieldNoticeIcon" onClick={() => handleRemoveItem(index)}><FaMinusCircle /></div>)}
        </div>
      ))}
    </>
  );
};

export default PlateDynamicInputList;
